export { default } from './Menu24';
